import PostsForm from "./classes/posts-form";    
import initialiseVideoPlayer from "./functionality/vimeo-player";
import initialiseReciteMe from "./functionality/reciteme";
import initialiseSplide from "./functionality/splide";
import initialiseNavSearch from "./functionality/nav-search";
import ArrowStepCards from "./classes/arrow-step-cards";
import DropdownCard from "./classes/dropdown-card";

new PostsForm();
new DropdownCard();
initialiseVideoPlayer();
initialiseReciteMe();
initialiseSplide();
initialiseNavSearch();

const instances = document.querySelectorAll<HTMLElement>('.asc-r');
instances.forEach(instance => new ArrowStepCards(instance));
